let currentPage = 1;
jQuery("#load-more").on("click", function (e) {
  e.preventDefault();
  currentPage++; // Do currentPage + 1, because we want to load the next page

  jQuery.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    dataType: "json",
    data: {
      action: "load_more",
      paged: currentPage,
    },
    success: function (res) {
      if( currentPage >= res.max ) {
        jQuery('#load-more').hide();
      }
      jQuery(".blog-posts .row").append(res.html);

    },
  });
});
